import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);
const v1 = '/rest/v1.0';

export const GET_PERFORMER_VIDEOS = `${BASE_URL}${v1}/marketplace/videos`;
export const UPDATE_ORDER = `${BASE_URL}${v1}/marketplace/videos/order`;
export const GET_VIDEOS_BY_DATE = `${BASE_URL}${v1}/marketplace/stats/insights`;

export default {
  GET_PERFORMER_VIDEOS,
  UPDATE_ORDER,
  GET_VIDEOS_BY_DATE,
};
